import { Renderer2, Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CompSimuladorSeguroComponent } from 'src/app/templates/comp-simulador-seguro/comp-simulador-seguro.component';

import { ReactiveFormsModule, FormsModule } from '@angular/forms';

@Component({
    selector: 'app-simular',
    templateUrl: './simular.component.html',
    styleUrls: ['./simular.component.css'],
    imports: [CompSimuladorSeguroComponent, ReactiveFormsModule, FormsModule]
})
export class SimularComponent implements OnInit {

  @ViewChild('compSimuladorSeguro', {static: false}) compSimSeg: CompSimuladorSeguroComponent;

  idade: number = null;

  constructor(private renderer: Renderer2) {}

  ngOnInit() {
    this.renderer.addClass(document.body, 'app-autoatendimento');
  }

  carregarFatores(){

    if(this.idade>=10){

      if(this.idade<14 || this.idade>65){
        alert("A idade deve estar entre 14 e 65 anos");
        this.idade=null;
        this.compSimSeg.loading=true;
        return false;
      }
  
      this.compSimSeg.init();
      this.compSimSeg.carregarFatoresDeCalculo(this.idade);
    }
   
  }

}
